'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformTryExpression = transformTryExpression;
exports.transformTryStatement = transformTryStatement;

var _types = require('../types');

var _types2 = _interopRequireDefault(_types);

var _tails = require('../helpers/tails');

var _blocks = require('../helpers/blocks');

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function normalizeTryStatement(node, path) {
  var _node$handler;

  // Turn stuff into blocks as needed
  if (node.block) node.block = (0, _blocks.toBlockStatement)(node.block);
  if ((_node$handler = node.handler) == null ? void 0 : _node$handler.body) node.handler.body = (0, _blocks.toBlockStatement)(node.handler.body);
  if (node.finalizer) node.finalizer = (0, _blocks.toBlockStatement)(node.finalizer);
  // Paramless handler gets a default param
  if (node.handler && !node.handler.param) {
    node.handler.param = path.scope.generateUidIdentifier("err");
  } // Generate default handler
  if (!node.handler && !node.finalizer) {
    var errId = path.scope.generateUidIdentifier("err");
    node.handler = _types2.default.catchClause(errId, _types2.default.blockStatement([_types2.default.expressionStatement(errId)]));
  }
}function transformVarDeclTryExpression(path, tryExprPath) {
  var node = tryExprPath.node;

  // Starting from `const x = try ...`
  // Add `let _val`
  //    let _val
  //    const x = try ...

  var resRef = path.scope.generateUidIdentifier("val");
  path.insertBefore(_types2.default.variableDeclaration("let", [_types2.default.variableDeclarator(resRef)]));

  // replace `try ...` with `_val`
  //    let _val
  //    const x = _val
  var declaratorPath = path.get("declarations.0");
  declaratorPath.node.init = resRef;

  // Turn the original node into a try statement and add it before the decl
  //    let _val
  //    try ...
  //    const x = _val
  node.type = "TryStatement";
  normalizeTryStatement(node, tryExprPath);
  path.insertBefore(node);

  // Re-tail the `try` statement so it assigns its final value to `_val`
  var tryPath = path.getPrevSibling();
  (0, _tails.transformTails)(tryPath, false, false, function (node) {
    return (0, _astLocUtils.placeAtNode)(_types2.default.assignmentExpression("=", resRef, node), node);
  });
}function transformPessimizedTryExpression(path) {
  var node = path.node;

  // If there are any awaits beneath us, we need async.

  var needsAsync = false;
  path.traverse({
    noScope: true,

    Function(path) {
      path.skip();
    }, AwaitExpression(awaitPath) {
      needsAsync = true;
      return awaitPath.stop();
    }, YieldExpression(yieldPath) {
      throw yieldPath.buildCodeFrameError("`yield` is not allowed in `try` expressions.");
    }, ReturnStatement(returnPath) {
      throw returnPath.buildCodeFrameError("`return` is not allowed in `try` expressions.");
    } });

  node.type = "TryStatement";
  normalizeTryStatement(node, path);

  var iife = _types2.default.callExpression(_types2.default.arrowFunctionExpression([], _types2.default.blockStatement([node]), needsAsync), []);

  path.replaceWith(iife);
}function isVarDeclTryExpr(path) {
  return (0, _types.isa)(path.parent, "VariableDeclarator") && path.parentPath.parent.declarations.length === 1 && path.parentPath.parentPath.listKey === "body";
}function transformTryExpression(path, isLinter) {
  if (isVarDeclTryExpr(path)) {
    transformVarDeclTryExpression(path.parentPath.parentPath, path, isLinter);
  } else {
    transformPessimizedTryExpression(path, isLinter);
  }
}function transformTryStatement(path) {
  var node = path.node;

  normalizeTryStatement(node, path);
  path.replaceWith(node);
}